import { Image } from 'expo-image';
import React, { useState } from 'react';
import { Modal as ReactModal, Pressable, TouchableOpacity, View, Platform, KeyboardAvoidingView } from 'react-native'
import tw from '../styles/tailwind';
import Text from './Text';
import Icon from './IcomoonIcon';


type ModalProps = {
  onRequestClose: () => void,
  title?: string,
  backgroundClosesModal?: boolean,
  style?: object,
  children: React.ReactElement,
}

export default function Modal({ children, onRequestClose, title, backgroundClosesModal=true, style } : ModalProps) {
  return (
    <ReactModal style={tw``} visible transparent>
      <View style={tw`flex-1 items-center justify-center`}>
        <Pressable style={tw`absolute left-0 w-full top-0 h-full bg-black/50`} onPress={backgroundClosesModal ? onRequestClose : null} />

        <View style={tw.style(
          `bg-white rounded-xl shadow-lg max-h-[90vh]`,
          // Platform.OS != "web" && `flex-grow-1`,
          style?.modal
        )}>
          {/* Titulo / boton cerrar */}
          <View style={tw.style(`items-center bg-gray-100 rounded-t-xl`, title && `py-2`)}>
            {
              title &&
                <Text style={tw`text-base font-bold text-center`}>{title}</Text>
            }
          </View>

          <View style={tw.style(`py-4 px-4`, style?.content)}>
            {/* <KeyboardAvoidingView
              behavior={Platform.OS === "ios" ? "padding" : "height"}
              style={tw`flex-1`}
            > */}
            {children}
            {/* </KeyboardAvoidingView> */}
          </View>

          <TouchableOpacity onPress={onRequestClose} style={tw`absolute right-3 top-[10px]`}>
            <Icon name='close' size={20} color={tw.color('red-500')} />
          </TouchableOpacity>
        </View>
      </View>
    </ReactModal>
  )
}